import { isSavedTracks } from './index'
import axios from './axios'

const getRecent = async (limit = 50, time_range = "long_term") => {

    try {
        let { data: { items } } = await axios.get('/me/player/recently-played', {
            params: {
                limit,
                time_range
            }
        })
        let savedTracks = await isSavedTracks(items.map(i => i.track.id))
        items = items.map((i, k) => {
            return {
                ...i,
                track: {
                    ...i.track,
                    isSaved: savedTracks[k]
                }
            }
        })

        return {
            data: items,
            error: false,
            loading: false
        }

    } catch (e) {
        let err = { ...e }
        if (err.hasOwnProperty('response')) {
            let { response: { data: { error } } } = err
            return {
                error: true,
                status: error.status,
                message: error.message
            }
        } else {
            return {
                error: true,
                status: "400",
                message: "Something happend with tracks"
            }
        }
    }
}

export default getRecent